import {
  CalculationDetailFormValues,
  CalculationEditFormValues,
  CalculationPrices,
  CalculationSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CALCULATION SEARCH
---------------------------------------------------------------------------------------------*/
export const initialCalculationSearchForm: CalculationSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
  CALCULATION CREATE — INITIAL PRICES
  Hardkodirane početne cijene stavki razrade. Korisnik ih može mijenjati u
  tablici; payload uvijek sadrži i ove inicijale (INITIAL_TOTAL) i aktualan
  zbroj (total) tako da backend ima i referencu i izmijenjenu vrijednost.
---------------------------------------------------------------------------------------------*/
export const INITIAL_PRICES: CalculationPrices = {
  leasing: 1314.06,
  tireSummer: 254.54,
  tireSummerChange: 13.94,
  tireWinter: 264.12,
  tireWinterChange: 13.94,
  vehicleServices: 603.89,
  vehicleTechnicalInspection: 50.46,
  vehicleToll: 175.19,
  vehicleInsurance: 355.82,
  vehicleComprehensiveInsurance: 2512.36,
  vehicleAnnualTax: 199.08,
  vehicleRtvFee: 10.62,
  vehicleFireExtinguisher: 14.6,
};

export const INITIAL_TOTAL: number = Object.values(INITIAL_PRICES).reduce(
  (sum, value) => sum + value,
  0
);

/*-------------------------------------------------------------------------------------------
  CALCULATION CREATE — INITIAL FORM
---------------------------------------------------------------------------------------------*/
export const initialCalculationCreateFormValues: CalculationEditFormValues = {
  name: null,
  vehicleManufacturerId: "",
  vehicleModelId: null,
  vehicleTypeId: null,
  rentMonths: 12,
  rentKm: 10000,
  leasingId: null,
  prices: INITIAL_PRICES,
};

/*-------------------------------------------------------------------------------------------
  CALCULATION DETAIL
---------------------------------------------------------------------------------------------*/

export const initialCalculationDetailForm: CalculationDetailFormValues = {
  id: null,
  name: null,
};

/*-------------------------------------------------------------------------------------------
  CALCULATION CREATE — RENT PERIOD & MILEAGE BOUNDS
---------------------------------------------------------------------------------------------*/
export const CALCULATION_RENT_MONTHS_MIN: number = 12;
export const CALCULATION_RENT_MONTHS_MAX: number = 60;
export const CALCULATION_RENT_MONTHS_STEP: number = 12;

export const CALCULATION_RENT_KM_MIN: number = 5000;
export const CALCULATION_RENT_KM_MAX: number = 180000;
export const CALCULATION_RENT_KM_STEP: number = 5000;
